import { render, staticRenderFns } from "./dormBedChange.vue?vue&type=template&id=5a2ad56f&scoped=true"
import script from "./dormBedChange.vue?vue&type=script&lang=js"
export * from "./dormBedChange.vue?vue&type=script&lang=js"
import style0 from "./dormBedChange.vue?vue&type=style&index=0&id=5a2ad56f&prod&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a2ad56f",
  null
  
)

export default component.exports